import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useCertificationBusinessPartner,
  useFind: useCertificationBusinessPartners,
  useCreate: useCertificationBusinessPartnerCreation,
  useUpdate: useCertificationBusinessPartnerUpdate,
  useDelete: useCertificationBusinessPartnerDeletion,
} = getCRUDHooks<{ id: number; name: string; logo: string }>({
  entityName: 'certificationBusinessPartnes',
  getHelper: () => clientApi.getOCClient().helpers.learningContent.certificationBusinessPartners,
});

export {
  useCertificationBusinessPartner,
  useCertificationBusinessPartners,
  useCertificationBusinessPartnerCreation,
  useCertificationBusinessPartnerUpdate,
  useCertificationBusinessPartnerDeletion,
};
